import { ProductoAcuerdo } from './producto-acuerdo.model';

import { TarifarioAdicional } from './tarifario-adicional.model';
import { TarifarioPorCantidad } from './tarifario-por-cantidad.model';
import { TipoMoneda } from '../cliente/tipoMoneda.model';

export class Tarifario {

  producto: ProductoAcuerdo;
  tipoMoneda: TipoMoneda;
  precioDefault: number;

  adicionales: TarifarioAdicional[] = [];
  preciosXCantidad: TarifarioPorCantidad[] = [];

  constructor() {
  }



}



// WEBPACK FOOTER //
// ./src/app/acuerdo/tarifario.model.ts